
const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

const containsNumbers = (str) => {
    return /\d/.test(str);
}

function isNumValid(value) {
    return /^(\+?\d{1,3})?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(value);
}

function saveForm() {
    let data = {
        name: document.getElementById('first_name').value,
        surname: document.getElementById('last_name').value,
        role: document.getElementById('role-field').value,
        company: document.getElementById('company_name').value,
        phone: document.getElementById('phone_number').value,
        email: document.getElementById('k_id_email').value,
        message: document.getElementById('message-field').value
    };
    let error = "";
    let erel = document.querySelector('span.error');
    if ( data.name.length < 2 || containsNumbers(data.name) ) {
        error = window.theme.form.name_error;
        erel.innerHTML = error;
        erel.classList.add('active');
        document.getElementById('name').classList.add('error');
        throw new Error();
    } else {
        document.getElementById('name').classList.remove('error');
    }

    if ( data.surname.length < 2 || containsNumbers(data.surname) ) {
        error = window.theme.form.surname_error;
        erel.innerHTML = error;
        erel.classList.add('active');
        document.getElementById('surname').classList.add('error');
        throw new Error();
    } else {
        document.getElementById('surname').classList.remove('error');
    }

    if ( data.role.length < 3 || containsNumbers(data.role) ) {
        error = window.theme.form.role_error;
        erel.innerHTML = error;
        erel.classList.add('active');
        document.getElementById('role').classList.add('error');
        throw new Error();
    } else {
        document.getElementById('role').classList.remove('error');
    }

    if ( data.company.length < 5 ) {
        error = window.theme.form.company_error;
        erel.innerHTML = error;
        erel.classList.add('active');
        document.getElementById('company').classList.add('error');
        throw new Error();
    } else {
        document.getElementById('company').classList.remove('error');
    }

    if ( !isNumValid(data.phone) ) {
        error = window.theme.form.phone_error;
        erel.innerHTML = error;
        erel.classList.add('active');
        document.getElementById('phone').classList.add('error');
        throw new Error();
    } else {
        document.getElementById('phone').classList.remove('error');
    }

    if ( !validateEmail(data.email) ) {
        error = window.theme.form.email_error;
        erel.innerHTML = error;
        erel.classList.add('active');
        document.getElementById('email').classList.add('error');
        throw new Error();
    } else {
        document.getElementById('email').classList.remove('error');
    }

    if ( data.message.length < 5 ) {
        error = window.theme.form.message_error;
        erel.innerHTML = error;
        erel.classList.add('active');
        document.getElementById('message').classList.add('error');
        throw new Error();
    } else {
        document.getElementById('message').classList.remove('error');
    }

    if ( error.length === 0 ) {
        setTimeout(() => {
            window.location.href = "/pages/thank-you";
        }, "1000")
    }
}

document.querySelector('.form-section__right-side').addEventListener("submit", checkForm, true);
function checkForm(event) {
    try {
        saveForm();
    } catch (errorMessage) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    }
}

clearError = function() {
    document.querySelector('span.error').classList.remove('active');
}